import { createTheme } from '@mui/material/styles';

export const Theme = createTheme({
    components: {
        MuiList: {
            styleOverrides: {
                root: {
                    backgroundColor: 'var(--color-muiBackground)',
                    color: 'var(--color-text)',
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    backgroundColor: 'var(--color-muiBackground)',
                    color: 'var(--color-text)',
                    svg: {
                        color: 'var(--color-text)',
                    }
                }
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    backgroundColor: 'var(--color-muiBackground)',
                    input: {
                        color: 'var(--color-text)',
                        "&.Mui-disabled": {
                            color : 'var(--color-primaryGrey)',
                            '-webkit-text-fill-color': 'var(--color-primaryGrey)',
                        }
                    },
                    label: {
                        color: 'var(--color-text)',
                    },
                    button: {
                        color: 'var(--color-text)',
                    }
                },
            },
        },
        MuiPopper: {
            styleOverrides: {
                root: {
                    backgroundColor: 'var(--color-muiBackground)',
                    color: 'var(--color-text)',
                }
            }
        },
        MuiPaper:{
            styleOverrides: {
                root: {
                    backgroundColor: 'var(--color-muiBackground)',
                    color: 'var(--color-text)',
                }
            }
        },
        MuiPaginationItem:{
            styleOverrides: {
                root: {
                    backgroundColor: 'var(--color-muiBackground)',
                    color: 'var(--color-text)',
                }
            }
        },
        MuiTab:{
            styleOverrides: {
                root: {
                    color: 'var(--color-text)',
                }
            }
        },
    },
});